export const salaryHistoryActionTypes = {
  SALARYHISTORY_LIST_LOADING: "SALARYHISTORY_LIST_LOADING",
  SALARYHISTORY_LIST_LOAD_SUCCESS: "SALARYHISTORY_LIST_LOAD_SUCCESS",
  SALARYHISTORY_LIST_LOAD_FAIL: "SALARYHISTORY_LIST_LOAD_FAIL",
  EDIT_SALARYHISTORY_VIEW: "EDIT_SALARYHISTORY_VIEW",
  CANCEL_EDIT_SALARYHISTORY: "CANCEL_EDIT_SALARYHISTORY",
  EDIT_SALARYHISTORY_LOADING: "EDIT_SALARYHISTORY_LOADING",
  EDIT_SALARYHISTORY_SUCCESS: "EDIT_SALARYHISTORY_SUCCESS",
  EDIT_SALARYHISTORY_FAIL: "EDIT_SALARYHISTORY_FAIL",
  SALARYHISTORY_BY_EMPLOYEE: "SALARYHISTORY_BY_EMPLOYEE",
  SHOW_EMPLOYEE_SALARY_HISTORY_DETAIL: "SHOW_EMPLOYEE_SALARY_HISTORY_DETAIL",
  SHOW_Salary_List: "SHOW_Salary_List",
  GET_EMPLOYEE_SALARY_HISTORY: "GET_EMPLOYEE_SALARY_HISTORY",
  SET_EMPLOYEE_SALARY_DETAILS: "SET_EMPLOYEE_SALARY_DETAILS",
  RESET_SALARY_VIEW: "RESET_SALARY_VIEW",
  SET_EMPLOYEE_SALARY_DETAILS_SPECIFIC: "SET_EMPLOYEE_SALARY_DETAILS_SPECIFIC",
  SET_LATEST_SALARY: "SET_LATEST_SALARY",
  SET_LOADER_SALARYHISTORY: "SET_LOADER_SALARYHISTORY",
  CLEAR_SALARY_ERRORS: "CLEAR_SALARY_ERRORS"
};
